module.exports = __webpack_public_path__ + "static/bg-df501dfb9958e16143f737ac16a9f5b8.png";